import { saveTransformation as saveTransformationDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type ComplianceProps = ApiMethodBase & {}

export const saveTransformation = ({
    eventEmitter,
}: ComplianceProps) => {
    saveTransformationDiagram();
};
